import { ApolloClientFactory } from '../../domain/apolloClientFactory';
import { getSize } from '../../helpers/products';
import { observer } from 'mobx-react';
import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, Link } from 'react-router-dom';
import Form from '../../components/FormGenerator/Form';
import Attributes from '../../components/Query/Attributes/FilterableAttributes';
import DeliveryMethods from '../../components/Query/DeliveryMethods';
import FullVariants from '../../components/Query/Products/FullVariants';
import LoginBox from '../../components/Query/User/Login';
import { expectedDelivery } from '../../helpers/expectedDelivery';
import { IOrderPrice } from '../../interfaces/interfaces';
import { Button, Container, Loader, OrderBox, Section, Tabs, Title, Svg } from '../../modules/modules';
import AuthService from '../../services/AuthService';
import CartService from '../../services/CartService';
import { OrderBasketStore } from './OrderBasketStore';
import { adopt } from 'react-adopt';
import FlashStore from '../../services/FlashStore';
import CountryService from '../../services/CountryService';

interface IOrderState {
  price: IOrderPrice;
  loaded: boolean;
  ordering: boolean;
  privacy: boolean;
  terms: boolean;
}

interface IOrderBasketProps extends RouteComponentProps<{ language: string }> {
  createOrder: MutationFunc;
  createPayment: MutationFunc;
}

interface ICartParams {
  ids: Array<any>;
  render: () => void;
}

const CartParams = adopt({
  deliveryMethods: <DeliveryMethods />,
  attributes: <Attributes />,
  variants: ({ ids, render }: ICartParams) => <FullVariants ids={ids}>{render}</FullVariants>
});

@observer
class OrderBasket extends React.Component<IOrderBasketProps, IOrderState> {
  public state: IOrderState;
  private formValidators: any;

  public static getDerivedStateFromProps(props: IOrderBasketProps | any, state: IOrderState) {
    if (props.data.userInfo != undefined && !state.loaded) {
      const userInfo = props.data.userInfo as GQL.IUser;

      OrderBasketStore.GetInstance().formsValues = {
        ...OrderBasketStore.GetInstance().formsValues,
        delivery: {
          ...OrderBasketStore.GetInstance().formsValues.delivery,
          Firstname: userInfo.invoiceFirstName,
          Lastname: userInfo.invoiceLastName,
          Email: userInfo.email,
          Phone: userInfo.phone,
          AddressZip: userInfo.invoiceZip,
          AddressStreetNumber: userInfo.invoiceHouseNumber,
          AddressStreet: userInfo.invoiceStreet,
          AddressCountry: userInfo.invoiceCountry,
          AddressCity: userInfo.invoiceCity,
          AddressAddressZip: userInfo.invoiceZip,
          AddressAddressStreetNumber: userInfo.invoiceHouseNumber,
          AddressAddressStreet: userInfo.invoiceStreet,
          AddressAddressCountry: userInfo.invoiceCountry,
          AddressAddressCity: userInfo.invoiceCity,
          Newsletter: userInfo.receiveNewsletter,
          Company: userInfo.companyName,
          CompanyRegistrationNumber: userInfo.companyRegistrationNumber,
          CompanyVatNumber: userInfo.companyVatNumber
        } as any
      };

      const newState = {
        ...state,
        loaded: true
      };

      return newState;
    }

    return state;
  }

  constructor(props: any) {
    super(props);
    this.formValidators = {};
    this.handleSend = this.handleSend.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      price: {
        Shipment: -1,
        Payment: -1,
        Total: 0,
        DeliveryInsurance: null,
      },
      loaded: false,
      ordering: false,
      terms: false,
      privacy: false,
    };
  }

  /**
   * Přepočet ceny objednávky
   * 
   * @param deliveryMethodId
   */
  public countPrice(deliveryMethodId: string | undefined) {
    let totalPrice = CartService.GetInstance().totalPrice;

    // Add shipping and payment
    const price = this.state.price;
    const deliveryPrice = deliveryMethodId
      ? CartService.GetInstance().isFreeDelivery(deliveryMethodId)
        ? 0
        : price.Shipment
      : price.Shipment;
    totalPrice += Math.max(deliveryPrice || 0, 0) + Math.max(price.Payment || 0, 0);
    this.setState({ price: { ...this.state.price, ['Total']: totalPrice } });
  }

  public async handleChange(value: any, field: string, form: string, elements?: Array<any>, paymentElements?: Array<any>) {
    const store = OrderBasketStore.GetInstance();
    const formsValues = store.formsValues;
    formsValues[form][field] = value;
    store.formsValues = formsValues;

    if (field === 'Shipment' || field === 'Payment') {
      if (field === 'Shipment') {
        // vybraný způsob dopravy
        const chosenShipment = (elements || []).find((d: GQL.IDeliveryMethod) => d.id === value);
        // vybraný způsob platby
        const paymentId = store.formsValues.payment.Payment;
        const chosenPayment = paymentId ? (paymentElements || [{}]).find((p: GQL.IPaymentMethod) => p.id === paymentId) : undefined;

        // došlo ke změně výběru dopravy, která nemá zvolenou platbu z předchozí dopravy
        if (paymentId && !chosenPayment) {
          store.formsValues.payment.Payment = null;
          formsValues.payment.Payment = null;
        }

        if (chosenPayment) {
          await this.setState({
            price: { ...this.state.price, [field]: chosenShipment.price, Payment: chosenPayment.price || 0 }
          });
        } else {
          await this.setState({
            price: { ...this.state.price, [field]: chosenShipment.price }
          });
        }
      } else {
        // vybraný způsob platby (ID)
        const paymentId = store.formsValues.payment.Payment;
        const chosenPayment = (paymentElements || []).find((p: GQL.IPaymentMethod) => p.id === paymentId);
        await this.setState({
          price: { ...this.state.price, [field]: chosenPayment.price }
        });
      }

      // vybraný způsob dopravy
      const deliveryId = store.formsValues.shipment.Shipment;
      const deliveryMethod = (elements || []).find((d: GQL.IDeliveryMethod) => d.id === deliveryId) || {};
      this.countPrice(deliveryMethod.id);
    }

    this.forceUpdate();
  }

  public setFormState(form: string, fields: any) {
    const store = OrderBasketStore.GetInstance();

    const formsFields = store.formsFields;
    formsFields[form] = fields;
    store.formsFields = formsFields;

    this.forceUpdate();
  }

  public async handleSend(paymentMethods: Array<GQL.IPaymentMethod>, deliveryMethods: Array<GQL.IDeliveryMethod>) {
    if (!this.state.terms || !this.state.privacy) {
      FlashStore.GetInstance().showMessage('Before you complete your order, you must agree to the terms of use and processing of your personal information.', 'error');
      return;
    }

    const { countryCode, language } = CountryService.GetInstance();

    const validators = this.formValidators;
    const store = OrderBasketStore.GetInstance();

    let valid = true;

    for (const key in this.formValidators) {
      if (!this.formValidators.hasOwnProperty(key)) {
        continue;
      }

      const tempValid = await validators[key].validate((parentFields: any) => {
        this.setFormState(key, parentFields);
      });

      if (!tempValid) {
        valid = false;
      }
    }

    const paymentId = store.formsValues.payment.Payment;
    const deliveryId = store.formsValues.shipment.Shipment;

    if (!valid || paymentId == undefined || deliveryId == undefined) {
      FlashStore.GetInstance().showMessage('Prosíme, doplňte chybějící údaje.', 'error', 4000);
      return;
    }

    // vybraný způsob platby
    const paymentMethod = paymentMethods.find((p: GQL.IPaymentMethod) => p.id === paymentId);
    // vybraný způsob dopravy
    const deliveryMethod = deliveryMethods.find((d: GQL.IDeliveryMethod) => d.id === deliveryId);

    if (!paymentMethod || !deliveryMethod) {
      return;
    }

    const values = store.formsValues.delivery as any;
    const notes = store.formsValues.notes as any;

    if (!this.state.ordering) {
      this.setState({ ordering: true }, async () => {
        const result = await this.props.createOrder({
          variables: {
            order: {
              deliveryMethodId: deliveryMethod.id,
              paymentMethodId: paymentMethod.id,
              currencyId: CountryService.GetInstance().currency.id,
              email: values.Email,
              phone: values.Phone,
              companyName: values.Company,
              voucherIds: CartService.GetInstance().voucherIds,
              companyRegistrationNumber: values.CompanyRegistrationNumber,
              companyVatNumber: values.CompanyVatNumber,
              language,
              invoiceFirstName: values.Firstname,
              invoiceLastName: values.Lastname,
              invoiceStreet: values.AddressStreet,
              invoiceHouseNumber: values.AddressStreetNumber,
              invoiceZip: values.AddressZip,
              invoiceCity: values.AddressCity,
              invoiceCountry: values.AddressCountry,
              deliveryStreet: values.DeliveryAddressStreet || values.AddressStreet,
              deliveryHouseNumber: values.DeliveryAddressStreetNumber || values.AddressStreetNumber,
              deliveryZip: values.DeliveryAddressZip || values.AddressZip,
              deliveryCity: values.DeliveryAddressCity || values.AddressCity,
              deliveryCountry: values.DeliveryAddressCity
                ? values.DeliveryAddressCountry || values.AddressCountry
                : values.AddressCountry,
              notes: notes.Notes,
              items: CartService.GetInstance().orderItems.map(o => {
                return {
                  variantId: o.variant.id,
                  quantity: o.quantity
                };
              })
            }
          }
        });

        if (
          Array.isArray(result.data.createOrder.maxAvailableStock) &&
          result.data.createOrder.maxAvailableStock.length > 0
        ) {
          this.setState({ ordering: false });
          ApolloClientFactory.GetClient().resetStore();
          this.props.history.push(`/${countryCode}/cart`);
        } else {
          CartService.GetInstance().removeEverything();
          OrderBasketStore.ResetInstance();

          const { order } = result.data.createOrder;
          const { email, orderNumber } = order;

          this.setState({ ordering: false });

          // platba online
          if (paymentMethod.gateway) {
            this.sendGoogleEcommerce(language, order)
              .then(() => {
              // přesměr na stránku s potvrzením objednávky
              this.props.history.push(`/${countryCode}/order-finished/${orderNumber}/${order.id}`);
            });
          } else {
            this.sendGoogleEcommerce(language, order)
              .then(() => {
                this.props.history.push(`/${countryCode}/order-finished/${orderNumber}/${order.id}`, {
                  orderNumber,
                  email
                });
              });
          }
        }
      });
    }
  }

  public componentDidMount() {
    this.countPrice(undefined);
  }

  public render() {
    const store = OrderBasketStore.GetInstance();
    const { countryCode, language } = CountryService.GetInstance();

    if (CartService.GetInstance().getAllVariantIds().length == 0) {
      this.props.history.push(`/${countryCode}/cart`);
      return null;
    }

    return (
      <main>
        <CartParams
          ids={CartService.GetInstance().getAllVariantIds()}
        >
          {({ deliveryMethods, variants, attributes }: any) => {
            if (deliveryMethods.deliveryMethods.loading ||
              variants.fullVariants.loading ||
              attributes.attributes.loading) {
              return <Loader />;
            }

            // rekalkulace cen pro případ že se změnila měna
            // const cartContent = CartService.GetInstance().getAllVariantIds().map(variantId => {
            //     const quantity = CartService.GetInstance().getQuantityForVariant(variantId);
            //     const itemPrice = findPrice(variants.find((variant: any) => {
            //         return variant.id === variantId;
            //     }).prices);
            //     const recommendedItemPrice = itemPrice;
            //     return {
            //         variant, quantity, itemPrice, recommendedItemPrice
            //     };
            // });
            // for (const item of cartContent) {
            //     CartService.GetInstance().removeItemCompletelyFromCart(item.variantId);
            //     CartService.GetInstance().addToCart(item.variant, item.recommendedItemPrice);
            // }

            // dostupný seznam aktivních doprav
            const deliveryMethodsList = deliveryMethods.deliveryMethods.deliveryMethods;

            const eans = variants.fullVariants.variants;
            const attrs = attributes.attributes.attributes;

            const shipmentForm = store.formsFields.shipment.map((s: any) => {
              return {
                ...s,
                fields: deliveryMethodsList.map((d: GQL.IDeliveryMethod) => {
                  return {
                    id: d.id,
                    label: d.name[language],
                    description: d.deliveryTimeDays ? `U vás ${expectedDelivery(d.deliveryTimeDays)}` : '',
                    price: CartService.GetInstance().isFreeDelivery(d.id) ? 0 : d.price
                  };
                })
              };
            });

            // vybraný způsob dopravy
            const deliveryId = store.formsValues.shipment.Shipment;
            const selectedDelivery = deliveryId
              ? deliveryMethodsList.find((d: GQL.IDeliveryMethod) => d.id === deliveryId)
              : undefined;

            // cena dopravy
            const deliveryTotal = selectedDelivery
              ? CartService.GetInstance().isFreeDelivery(selectedDelivery.id as any)
                ? 0
                : this.state.price.Shipment
              : this.state.price.Shipment;

            // seznam platebních metod
            const paymentMethods = selectedDelivery
              ? selectedDelivery.paymentMethods
                .filter((p: GQL.IPaymentMethod) => p.active === true)
                .map((p: GQL.IPaymentMethod) => {
                  return {
                    id: p.id,
                    label: p.name[language],
                    description: p.description ? p.description[language] : '',
                    price: p.price,
                    image: p.image,
                    gateway: p.gateway,
                    priority: p.priority,
                    active: p.active,
                  };
                })
                .sort((a: GQL.IPaymentMethod, b: GQL.IPaymentMethod) => a.priority && b.priority && a.priority < b.priority ? -1 : 0)
              : [];

            // formulář výběru způsobu platby
            const paymentForm = store.formsFields.payment.map((s: any) => {
              return {
                ...s,
                fields: paymentMethods
              };
            });

            return (
              <Section>
                <Container>
                  {!this.state.loaded && AuthService.GetInstance().loggedIn && <Loader />}
                  <div className="order">
                    {this.state.ordering && <Loader />}
                    <div className="order__grid">
                      <div className="order__main">
                        <Title>Objednávka</Title>
                        <div className="mt-2 mt-sm-3">
                          {!AuthService.GetInstance().loggedIn && (
                            <Tabs
                              tabs={
                                AuthService.GetInstance().loggedIn
                                  ? ['Prihlaseny uzivatel']
                                  : ['Jednorázový nákup', 'Přihlásit se']
                              }
                            >
                              <div className="tab__item">
                                <div className="boundaries-md">
                                  <div className="form form--grid">
                                    {/* Delivery form */}
                                    <div className="form__section">
                                      <Title type="form">Adresa pro doručení</Title>
                                      <Form
                                        fields={store.formsFields.delivery as any}
                                        values={store.formsValues.delivery as any}
                                        formName="delivery"
                                        handleChange={this.handleChange}
                                      >
                                        {(form: any) => {
                                          this.formValidators.delivery = form;
                                        }}
                                      </Form>
                                    </div>

                                    {/* Notes */}
                                    <div className="form__section">
                                      <Title type="form">Poznámky</Title>
                                      <Form
                                        fields={store.formsFields.notes as any}
                                        values={store.formsValues.notes as any}
                                        formName="notes"
                                        handleChange={this.handleChange}
                                      >
                                        {(form: any) => {
                                          this.formValidators.notes = form;
                                        }}
                                      </Form>
                                    </div>

                                    <React.Fragment>
                                      <div className="form__section">
                                        <Title type="formRadio">
                                          Vyberte typ dopravy
                                        </Title>
                                        <Form
                                          fields={shipmentForm}
                                          values={store.formsValues.shipment}
                                          formName="shipment"
                                          handleChange={(value, field, form) => {
                                            const valueObject = deliveryMethodsList
                                              .find((d: GQL.IDeliveryMethod) => d.id === value);

                                            return this.handleChange(
                                              value,
                                              field,
                                              form as any,
                                              deliveryMethodsList,
                                              valueObject ? valueObject.paymentMethods : null
                                            );
                                          }}
                                        >
                                          {(form: any) => {
                                            this.formValidators.shipment = form;
                                          }}
                                        </Form>
                                      </div>
                                      {selectedDelivery && (
                                        <div className="form__section">
                                          <Title type="formRadio">
                                            Vyberte typ platby
                                          </Title>
                                          <Form
                                            fields={paymentForm}
                                            values={store.formsValues.payment}
                                            formName="payment"
                                            handleChange={(value, field, form) =>
                                              this.handleChange(
                                                value,
                                                field,
                                                form as any,
                                                deliveryMethodsList,
                                                paymentMethods
                                              )
                                            }
                                          >
                                            {(form: any) => {
                                              this.formValidators.payment = form;
                                            }}
                                          </Form>
                                        </div>
                                      )}
                                    </React.Fragment>

                                    {/* Shipment form */}

                                    {/* Payment form */}
                                  </div>
                                </div>
                              </div>

                              <div className="tabs__item">
                                <div className="boundaries-md mb-3">
                                  <LoginBox
                                    onLogin={() => {
                                      (this.props as any).data.refetch();
                                    }}
                                    type="inPage"
                                  />
                                </div>
                              </div>
                            </Tabs>
                          )}
                          {AuthService.GetInstance().loggedIn && (
                            <div className="boundaries-md">
                              <div className="form form--grid">
                                {/* Delivery form */}
                                <div className="form__section">
                                  <Title type="form">Adresa pro doručení</Title>
                                  <Form
                                    fields={store.formsFields.delivery as any}
                                    values={store.formsValues.delivery as any}
                                    formName="delivery"
                                    handleChange={this.handleChange}
                                  >
                                    {(form: any) => {
                                      this.formValidators.delivery = form;
                                    }}
                                  </Form>
                                </div>

                                {/* Notes */}
                                <div className="form__section">
                                  <Title type="form">Poznámky</Title>
                                  <Form
                                    fields={store.formsFields.notes as any}
                                    values={store.formsValues.notes as any}
                                    formName="notes"
                                    handleChange={this.handleChange}
                                  >
                                    {(form: any) => {
                                      this.formValidators.notes = form;
                                    }}
                                  </Form>
                                </div>

                                <React.Fragment>
                                  <div className="form__section">
                                    <Title type="formRadio">Vyberte typ dopravy</Title>
                                    <Form
                                      fields={shipmentForm}
                                      values={store.formsValues.shipment as any}
                                      formName="shipment"
                                      handleChange={(value, field, form) => {
                                        const valueObject = deliveryMethodsList
                                          .find((d: GQL.IDeliveryMethod) => d.id === value);

                                        return this.handleChange(
                                          value,
                                          field,
                                          form as any,
                                          deliveryMethodsList,
                                          valueObject ? valueObject.paymentMethods : null
                                        );
                                      }}
                                    >
                                      {(form: any) => {
                                        this.formValidators.shipment = form;
                                      }}
                                    </Form>
                                  </div>
                                  {selectedDelivery && (
                                    <div className="form__section">
                                      <Title type="formRadio">Vyberte typ platby</Title>
                                      <Form
                                        fields={paymentForm}
                                        values={store.formsValues.payment as any}
                                        formName="payment"
                                        handleChange={(value, field, form) =>
                                          this.handleChange(
                                            value,
                                            field,
                                            form as any,
                                            deliveryMethodsList,
                                            paymentMethods
                                          )
                                        }
                                      >
                                        {(form: any) => {
                                          this.formValidators.payment = form;
                                        }}
                                      </Form>
                                    </div>
                                  )}
                                </React.Fragment>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="order__side">
                        <OrderBox
                          title="Summary"
                          products={(eans || []).map((variant: any) => {
                            const size = getSize(
                              variant,
                              attrs.filter((attr: any) => attr.tags.includes('size')),
                              language
                            );

                            return {
                              variant,
                              quantity: CartService.GetInstance().getQuantityForVariant(
                                variant.id
                              ),
                              size: size && size.toString()
                            };
                          })}

                          price={CartService.GetInstance().prices}
                        />
                      </div>
                    </div>
                    <div className="boundaries-md">
                      <div className="checkboxToggle">
                        <div>
                          <div className="checkbox">
                            <label className="checkbox__label">
                              <span>Souhlasím s <Link
                                style={{ textDecoration: 'underline' }}
                                target="_blank"
                                to={`/${countryCode}/conditions`}
                              >obchodními podmínkami</Link>.</span>
                              <input
                                className="checkbox__input"
                                name="terms"
                                defaultChecked={this.state.terms}
                                type="checkbox"
                                onClick={() => {
                                  this.setState({ terms: !this.state.terms });
                                }}
                              />
                              <div className="checkbox__checkmark" />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="checkboxToggle">
                        <div>
                          <div className="checkbox">
                            <label className="checkbox__label">
                              <span>Souhlasím se <Link
                                style={{ textDecoration: 'underline' }}
                                target="_blank"
                                to={`/${countryCode}/personal-data`}
                              >zpracováním osobních údajů</Link>.</span>
                              <input
                                className="checkbox__input"
                                name="privacy"
                                defaultChecked={this.state.privacy}
                                type="checkbox"
                                onClick={() => {
                                  this.setState({ privacy: !this.state.privacy });
                                }}
                              />
                              <div className="checkbox__checkmark" />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="nav-buttons nav-buttons--spaced">
                      <Button onClick={() => this.props.history.goBack()} type="return">
                        <Svg name="arrowReturn" />
                        Předchozí krok
                      </Button>
                      <Button
                        type="proceed"
                        onClick={() =>
                          this.handleSend(
                            selectedDelivery ? selectedDelivery.paymentMethods : undefined,
                            deliveryMethodsList
                          )
                        }
                      >
                        Dokončit objednávku
                        <Svg name="arrowProceed" />
                      </Button>
                    </div>
                  </div>
                </Container>
              </Section>
            );
          }}
        </CartParams>
      </main>
    );
  }

  /**
   * Odeslání objednávky do Google Tag Manageru
   *
   * @param {string} language
   * @param order
   * @returns {Promise<any>}
   */
  private sendGoogleEcommerce(language: string, order: any) {
    const country = JSON.parse(localStorage.getItem('country') || '') as any;
    const currencyCode = country && country.details && country.details.currency;
    return new Promise((resolve, reject) => {

      const dataLayer = (window as any).dataLayer;
      if (dataLayer && currencyCode) {

        const products: any[] = [];
        if (order && order.orderedItems) {
          order.orderedItems.forEach((item: any) => {
            products.push({
              id: item.ean,
              sku: item.sku,
              name: `${(item.name[language] ? item.name[language] : item.name.cs)}`,
              price: item.price,
              quantity: item.quantity,
            });
          });
        }
        const data = {
          event: 'Purchase',
          ecommerce: {
            currencyCode,
            purchase: {
              actionField: {
                id: order.orderNumber,
                revenue: order.grandTotal,
                shipping: order.deliveryTotal,
              },
              products
            }
          }
        };
        dataLayer.push(data);
      }

      resolve();
    });
  }
}

export default OrderBasket;



// WEBPACK FOOTER //
// ./src/pages/OrderBasket/OrderBasket.tsx